import { FiPlus, FiBell } from "react-icons/fi";

interface StudentsHeaderProps {
  onNewStudentClick: () => void;
  onNotificationAllClick?: () => void;
}

function StudentsHeader({
  onNewStudentClick,
  onNotificationAllClick,
}: StudentsHeaderProps) {
  return (
    <div className="mb-4 flex flex-col gap-3 sm:mb-6 sm:gap-4 md:mb-8 md:flex-row md:items-center md:justify-between">
      <div>
        <h2 className="bg-gradient-to-r from-purple-600 via-pink-600 to-blue-600 bg-clip-text text-3xl font-bold text-transparent dark:from-purple-400 dark:via-pink-400 dark:to-blue-400 sm:text-4xl">
          Alunos
        </h2>
        <p className="mt-2 text-sm font-medium text-gray-600 dark:text-gray-400">
          Gerencie seus alunos, planos e avaliações
        </p>
      </div>
      <div className="flex flex-col gap-2 sm:flex-row sm:gap-3">
        {onNotificationAllClick && (
          <button
            onClick={onNotificationAllClick}
            className="inline-flex items-center justify-center gap-2 rounded-lg border-2 border-purple-500 bg-white px-4 py-2.5 text-sm font-semibold text-purple-600 shadow-sm transition-all duration-300 hover:bg-gradient-to-r hover:from-purple-600 hover:to-pink-600 hover:text-white hover:shadow-lg dark:border-purple-500 dark:bg-gray-800 dark:text-purple-400 dark:hover:bg-gradient-to-r dark:hover:from-purple-600 dark:hover:to-pink-600 dark:hover:text-white sm:rounded-xl sm:px-6 sm:py-3"
          >
            <FiBell size={18} className="sm:h-5 sm:w-5" />
            <span className="hidden sm:inline">Notificar Alunos</span>
            <span className="sm:hidden">Notificar</span>
          </button>
        )}
        <button
          onClick={onNewStudentClick}
          className="inline-flex items-center justify-center gap-2 rounded-lg bg-gradient-to-r from-purple-600 to-pink-600 px-4 py-2.5 text-sm font-semibold text-white shadow-lg shadow-purple-500/50 transition-all duration-300 hover:scale-105 hover:shadow-xl sm:rounded-xl sm:px-6 sm:py-3"
        >
          <FiPlus size={18} className="sm:h-5 sm:w-5" />
          Novo Aluno
        </button>
      </div>
    </div>
  );
}

export default StudentsHeader;
